import { render, staticRenderFns } from "./PurchaseOrderForm.vue?vue&type=template&id=0924f2c4&scoped=true&"
import script from "./PurchaseOrderForm.js?vue&type=script&lang=js&"
export * from "./PurchaseOrderForm.js?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderForm.vue?vue&type=style&index=0&id=0924f2c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924f2c4",
  null
  
)

export default component.exports